export default __webpack_public_path__ + "static/saas-development-company-peerbits-2d90d3475b96f0c2daa8ad75605a48ad.png";